import { createSelector } from 'reselect';

import type { RootState } from '..';

export const selectAdmin = (state: RootState) => {
  return state.admin;
};

export const selectRole = (state: RootState) => {
  return state.admin.role;
};

export const selectScopes = (state: RootState) => {
  return state.admin.scope;
};

export const selectPictureUrl = (state: RootState) => {
  return state.admin.avatarUrl ?? '';
};

export const selectAuth = (state: RootState) => {
  return state.admin.auth;
};

export const selectName = createSelector(selectAdmin, admin => {
  if (admin.firstName && admin.lastName) {
    return `${admin.firstName} ${admin.lastName}`;
  }

  const nameByEmail = admin.email?.substring(0, admin.email.indexOf('@')).replace(/./g, ' ');

  if (nameByEmail) {
    return nameByEmail;
  }

  return '';
});

export const selectShortName = createSelector(selectAdmin, admin => {
  if (admin.firstName && admin.lastName) {
    return `${admin.firstName[0].toUpperCase()}${admin.lastName[0].toUpperCase()}`;
  } else if (admin.email) {
    const splittedName = admin.email.split('@')[0].split('.');

    return splittedName.length > 1
      ? `${splittedName[0].toUpperCase()}.${splittedName[1].toUpperCase()}`
      : admin.email[0].toUpperCase();
  }

  return null;
});
